const worldNationalities: string[] = [
  'Afghana',
  'Albanese',
  'Algerina',
  'Andorrana',
  'Angolana',
  'Argentina',
  'Armena',
  'Australiana',
  'Austriaca',
  'Azera',
  'Bahamense',
  'Bahreinita',
  'Barbadiana',
  'Belga',
  'Bengalese',
  'Beninese',
  'Bhutanese',
  'Bielorussa',
  'Birmana',
  'Boliviana',
  'Bosniaca',
  'Botswana',
  'Brasiliana',
  'Britannica',
  'Bruneiana',
  'Bulgara',
  'Burkinabé',
  'Burundese',
  'Cambogiana',
  'Camerunense',
  'Canadese',
  'Capoverdiana',
  'Ceca',
  'Centrafricana',
  'Ciadiana',
  'Cilena',
  'Cinese',
  'Cingalese',
  'Cipriota',
  'Colombiana',
  'Comoriana',
  'Congolese',
  'Costaricana',
  'Croata',
  'Cubana',
  'Danese',
  'Dominicana',
  'Ecuadoregna',
  'Egiziana',
  'Emiratina',
  'Eritrea',
  'Estone',
  'Etiope',
  'Figiana',
  'Filippina',
  'Finlandese',
  'Francese',
  'Gabonese',
  'Gambiana',
  'Georgiana',
  'Ghanese',
  'Giamaicana',
  'Giapponese',
  'Gibutiana',
  'Giordana',
  'Greca',
  'Grenadina',
  'Guatemalteca',
  'Guineana',
  'Guyanese',
  'Haitiana',
  'Honduregna',
  'Indiana',
  'Indonesiana',
  'Irachena',
  'Iraniana',
  'Irlandese',
  'Islandese',
  'Israeliana',
  'Italiana',
  'Ivoriana',
  'Kazka',
  'Keniana',
  'Kirgisa',
  'Kosovara',
  'Kuatiana',
  'Laotiana',
  'Lesothiana',
  'Lettone',
  'Libanese',
  'Liberiana',
  'Libica',
  'Liechtensteiniana',
  'Lituana',
  'Lussemburghese',
  'Macedone',
  'Malawiana',
  'Maldiviana',
  'Malesiana',
  'Malgascia',
  'Maliana',
  'Maltese',
  'Marocchina',
  'Marshallese',
  'Mauritana',
  'Mauriziana',
  'Messicana',
  'Micronesiana',
  'Moldava',
  'Monegasca',
  'Mongola',
  'Montenegrina',
  'Mozambicana',
  'Namibiana',
  'Nauruana',
  'Neozelandese',
  'Nepalese',
  'Nigeriana',
  'Nigerina',
  'Nordcoreana',
  'Norvegese',
  'Olandese',
  'Omanita',
  'Pachistana',
  'Palestinese',
  'Panamense',
  'Papuana',
  'Paraguaiana',
  'Peruviana',
  'Polacca',
  'Portoghese',
  'Qatariota',
  'Romena',
  'Ruandese',
  'Russa',
  'Salvadoregna',
  'Samoana',
  'Sanmarinese',
  'Saudita',
  'Senegalese',
  'Serba',
  'Sierraleonese',
  'Singaporiana',
  'Siriana',
  'Slovacca',
  'Slovena',
  'Somala',
  'Spagnola',
  'Statunitense',
  'Sudafricana',
  'Sudanese',
  'Sudcoreana',
  'Svedese',
  'Svizzera',
  'Tagika',
  'Tailandese',
  'Taiwanese',
  'Tanzaniana',
  'Tedesca',
  'Togolese',
  'Tongana',
  'Tunisina',
  'Turca',
  'Turkmena',
  'Ucraina',
  'Ugandese',
  'Ungherese',
  'Uruguaiana',
  'Uzbeka',
  'Vanuatuana',
  'Vaticana',
  'Venezuelana',
  'Vietnamita',
  'Yemenita',
  'Zambese',
  'Zimbabwese',
];
export default worldNationalities;
